import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Grid, Tab, Tabs, Button, Typography } from "@mui/material/";
import AddIcon from "@mui/icons-material/Add";
import actions from "../../Store/actions";
import { tabsRoutes, createTab } from "../Routes";
import styles from "../styles";
import { strings } from "../../common/i18n";
import { enums } from "../../common/lib";

export default () => {
    const dispatch = useDispatch();
    const params = useParams();

    let navigate = useNavigate();

    const { userOrganisations } = useSelector((state) => state);
    const { auditsTabValue } = useSelector((state) => state.appSettings);

    const auditsTab = useMemo(() => {
        // If stellantis org show draft tab
        if (
            userOrganisations?.item?.id ===
            enums.organisationIds.stellantisFinanceFrance
        )
            return tabsRoutes;
        return tabsRoutes.filter((item) => item.key !== "draft");
    }, [userOrganisations, tabsRoutes]);

    useEffect(() => {
        // Highlight the tab for the route we are on, however we got here
        // (deep link, bookmark, reload) - not just when a tab is clicked.
        const index = auditsTab.findIndex(
            (item) => item.key === params["*"]
        );
        if (index !== -1 && auditsTabValue !== index)
            dispatch(actions.appSettings.create.set({ auditsTabValue: index }));
    }, [params, auditsTab]);

    const onTabsChange = (event, value) => {
        dispatch(actions.appSettings.create.set({ auditsTabValue: value }));
        // Index into the tabs actually rendered: Draft is hidden for most
        // organisations, so tabsRoutes[value] can name a tab not on screen.
        const route = auditsTab[value];
        route && navigate(route.path);
    };

    const onCreateAudit = () => {
        navigate(createTab.path);
        /** Removing active from the tabs: select the hidden dummy tab, which
         * sits after the RENDERED tabs. tabsRoutes.length counted Draft even
         * where it is hidden, pointing MUI at a tab that does not exist
         * ("None of the Tabs' children match with 5"). */
        dispatch(
            actions.appSettings.create.set({
                auditsTabValue: auditsTab.length
            })
        );
    };

    return (
        <Grid container sx={{ py: 1 }}>
            <Grid item xs={12}>
                <Box sx={styles.tabListContainer}>
                    <Typography variant="h6" sx={styles.tabHeader}>
                        {strings("audits")}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={10}>
                <Tabs
                    onChange={onTabsChange}
                    indicatorColor="primary"
                    textColor="primary"
                    value={auditsTabValue}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {auditsTab.map(({ key, label }) => (
                        <Tab key={key} label={label} />
                    ))}
                    <Tab sx={styles.dummyTab}></Tab>
                </Tabs>
            </Grid>
            <Grid item xs={2} alignSelf="center" textAlign="right">
                <Button
                    disableElevation={true}
                    sx={styles.createTab}
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={onCreateAudit}
                    key={createTab.key}
                >
                    {createTab.label}
                </Button>
            </Grid>
        </Grid>
    );
};
